import {
    Notice,
    EstablishmentBadge,
} from "@hatch-digital-nl/abs-storybook/legacy";
import emergencyBlueImage from "../../../common/images/emergency-blue.svg";
import Skeleton from "react-loading-skeleton";
import { ShowEstablishmentDetailsItem } from "./ShowEstablishmentDetailsItem";
import { JSX } from "react";
import { useGetEstablishmentByIdQuery } from "../../../common/api/establishment";
import { useEstablishmentId } from "../../../common/utils/useEstablishmentId";
import { DataManagementMapbox } from "./ShowEstablishmentDetailsMapbox";

export const ShowEstablishmentDetailsContent = (): JSX.Element => {
    const { data: establishmentData, isLoading } = useGetEstablishmentByIdQuery(
        {
            id: useEstablishmentId(),
        },
    );

    if (isLoading || !establishmentData) {
        return <Skeleton height={"60rem"} borderRadius={"1.5rem"} />;
    }

    return (
        <div className="p-show-establishment-details__content">
            <Notice
                iconUrl={emergencyBlueImage}
                htmlContent={
                    '<p>Wil je wijzigingen door laten voeren in de bedrijfsgegevens van jouw vestiging. Neem dan per <a href="mailto:formule@absautoherstel.nl">e-mail</a> contact op met de servicedesk of bel ons op <a href="tel:09006611111">0900 - 66 11 11 1</a></p>'
                }
            />
            <div className={"p-show-establishment-details__content__title"}>
                <h2>Vestigingsgegevens</h2>
                <hr />
            </div>
            <div className="p-show-establishment-details__content__data">
                <div className="p-show-establishment-details__content__data-section">
                    <ShowEstablishmentDetailsItem
                        title={"Vestigingsnaam"}
                        content={establishmentData.name}
                    />
                    {establishmentData.badge && (
                        <div className="p-show-establishment-details__content__data-group">
                            <p className="p-show-establishment-details__content__label">
                                Badge:
                            </p>
                            <p className="p-show-establishment-details__content__value">
                                <EstablishmentBadge
                                    badge={establishmentData.badge}
                                />
                            </p>
                        </div>
                    )}
                    <ShowEstablishmentDetailsItem
                        title={"KvK-nummer"}
                        content={establishmentData.coc_number}
                    />
                    <ShowEstablishmentDetailsItem
                        title={"BTW-nummer"}
                        content={establishmentData.vat_number}
                    />
                    <ShowEstablishmentDetailsItem
                        title={"Postcode"}
                        content={establishmentData.address.zip_code}
                    />
                </div>
                <div className="p-show-establishment-details__content__data-section">
                    <ShowEstablishmentDetailsItem
                        title={"Straat"}
                        content={establishmentData.address.street}
                        small={true}
                    />
                    <ShowEstablishmentDetailsItem
                        title={"Plaats"}
                        content={establishmentData.address.city}
                        small={true}
                    />
                    <ShowEstablishmentDetailsItem
                        title={"Land"}
                        content={establishmentData.address.country}
                        small={true}
                    />
                </div>
            </div>
            <DataManagementMapbox
                address={{
                    lat: establishmentData.address.lat,
                    long: establishmentData.address.long,
                }}
            />
            <div className={"p-show-establishment-details__content__title"}>
                <h2>Contactgegevens</h2>
                <hr />
            </div>
            <div className="p-show-establishment-details__content__data">
                <div className="p-show-establishment-details__content__data-section">
                    <div className="p-show-establishment-details__content__data-group">
                        <p className="p-show-establishment-details__content__label">
                            Alg. telefoonnummer:
                        </p>
                        <p className="p-show-establishment-details__content__value">
                            {establishmentData.telephones.map(
                                (telephone: string, index: number) => (
                                    <span key={index}>
                                        {telephone}
                                        {index <
                                        establishmentData.telephones.length - 1
                                            ? ", "
                                            : ""}
                                    </span>
                                ),
                            )}
                        </p>
                    </div>
                    <div className="p-show-establishment-details__content__data-group">
                        <p className="p-show-establishment-details__content__label">
                            Alg. e-mailadres:
                        </p>
                        <p className="p-show-establishment-details__content__value">
                            {establishmentData.emails.map(
                                (email: string, index: number) => (
                                    <span key={index}>
                                        {email}
                                        {index <
                                        establishmentData.emails.length - 1
                                            ? ", "
                                            : ""}
                                    </span>
                                ),
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
